module.exports = __webpack_public_path__ + "img/HN.89df651c.svg";